// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"4478":"8de412b961457990","8047":"1cf8fe840d1ba3e5","8839":"8ffddb46dbdfe853"}[chunkId] + ".css";
};